export const getVersionedUrl = (url: string, version?: string) => {
    if (!version) return url;

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${encodeURIComponent(version)}`;
};
